module.exports = __webpack_public_path__ + "media/images/KVL_Ball-03-9dcdbeaf24eb7e0ebe763605474ae46d.svg";